import React, { useState, useEffect } from "react";
import { Table } from "antd";
import "react-quill/dist/quill.snow.css";
import "./Export.css";

function ExportData({ data, columns, type }) {
  const [tableColumns, setTableColumns] = useState([]);

  useEffect(() => {
    for (let i = 0; i < data.length; i++) {}
  }, [data]);

  return (
    <div className="flex flex-col justify-center items-center p-[20px]">
      <p className="blue text-[20px] mb-[10px] mt-[30px]">Vão ser exportados:</p>
      <p className="font-bold blue text-[40px] mt-[10px] mb-0">{data.length}</p>
      <p className="blue text-[20px] mt-0 mb-30">{type}</p>
      <Table columns={columns} dataSource={data} scroll={{ x: 1 }} />
    </div>
  );
}

export default ExportData;
